import { createAction } from 'redux-actions';

export default createAction('PUSH_TO_AD_QUEUE');



// WEBPACK FOOTER //
// ./src/action/pushToAdQueue.js